import React from "react";
import { Col } from "react-bootstrap";
import { StyledForm, paddingStyle } from "./style.module";
import { FormMandatoryIcon } from "./FormMandatoryIcon";
import { IsLoggedInUserViewer } from "../../../../hoc/withAuthRedirect";

export const FormTextField = ({
  id,
  elementkey,
  type,
  isDecimalAllowed,
  isSpecialCharsAllowed,
  isDisabled,
  isMandatory,
  maxLength,
  label,
  subtext,
  placeholder,
  onTextChange,
  value,
  defaultValue,
  byPassRoleCheck,
  error,
  handleOnBlur,
}) => {
  const isNumberInput = type === "number";
  const regex = /[ `!@#$%^&*()_+\-=£[\]{};':"\\|,.<>/?~]/g;

  //to handle negative and decimal number
  const handleNumberChange = (event) => {
    let inputValue = event.target.value;
    // Remove 'e' character if present
    inputValue = inputValue.replace(/e/gi, "");

    //handle decimal value
    if (isDecimalAllowed !== undefined && !isDecimalAllowed && inputValue.includes(".")) {
      const integerValue = inputValue.split(".")[0];
      inputValue = integerValue;
    }

    //check negative entry
    let positiveValue;
    if (isNumberInput) {
      positiveValue = inputValue === "" ? "" : parseFloat(inputValue) < 0 ? Math.abs(parseFloat(inputValue)) : inputValue;
    } else {
      positiveValue = inputValue;
    }
    event.target.value = positiveValue;

    onTextChange(event);
  };

  //to replace special characters
  const handleTextChange = (event) => {
    let inputValue = event.target.value;
    if (isSpecialCharsAllowed !== undefined && !isSpecialCharsAllowed) {
      const textValue = inputValue.replace(regex, "");
      inputValue = textValue;
    }
    const positiveValue = isNumberInput ? (inputValue === "" ? "" : Math.abs(parseFloat(inputValue))) : inputValue;
    event.target.value = positiveValue;
    onTextChange(event);
  };
  return (
    <StyledForm.Group
      as={Col}
      //md="6"
      lg="4"
      controlId={id}
      style={paddingStyle}
      key={elementkey}
    >
      <StyledForm.Label>
        {isMandatory && <FormMandatoryIcon />}
        {label}
      </StyledForm.Label>
      {subtext && <small style={{ color: "gray", display: "block", marginTop: "-0.5rem" }}>{subtext}</small>}
      <StyledForm.Control
        required={isMandatory}
        type={type}
        placeholder={placeholder}
        isInvalid={!!error}
        onChange={isNumberInput ? handleNumberChange : handleTextChange}
        value={value ? value : ""}
        defaultValue={defaultValue}
        maxLength={maxLength}
        disabled={isDisabled ? true : byPassRoleCheck ? false : IsLoggedInUserViewer()}
        onBlur={handleOnBlur}
      />
      {error && <StyledForm.Control.Feedback type="invalid">{error}</StyledForm.Control.Feedback>}
    </StyledForm.Group>
  );
};
